module.exports = __webpack_public_path__ + "img/PortableTracker.77ca97cf.png";